import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

import { AuthScheme, HttpHeader } from '../../../common/enums';

/**
 * Gets authorization JWT from response headers
 * @param headers Headers of response to get authorization JWT from
 * @returns Extracted string JWT or null if header was absent in response ones
 */
export const getTokenFromHeaders = (
  headers: RawAxiosResponseHeaders | AxiosResponseHeaders
): string | null => {
  const authHeaderValue: string | null = headers[HttpHeader.Authorization];
  return authHeaderValue ? authHeaderValue.replace(`${AuthScheme.Bearer} `, '') : null;
};
